export const getProductPrice = (product, currency) => {
    var _a, _b, _c, _d;
    const { prices, price, price_range } = product;
    if (!(prices === null || prices === void 0 ? void 0 : prices.row_total_including_tax)) {
        return price;
    }
    const grossPrice = (_a = prices.row_total_including_tax) !== null && _a !== void 0 ? _a : { value: 0 };
    const regularPrice = (_d = (_c = (_b = price_range === null || price_range === void 0 ? void 0 : price_range.minimum_price) === null || _b === void 0 ? void 0 : _b.regular_price) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0;
    return Object.assign(Object.assign({}, grossPrice), { currency: currency.code, regularPrice });
};
//# sourceMappingURL=getProductPrice.js.map